module.exports = __webpack_public_path__ + "static/img/37f02a140f5ec66a8c630b36a948f20e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/youshi_01.png
// module id = T6yn
// module chunks = 1